import React, { useState, useEffect } from "react";
import MainMenu from "../components/navigations/MainMenu";
import { useParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import ReactHtmlParser from "react-html-parser";

const NoticeDetail = () => {
  const [noticeDetail, setNoticeDetail] = useState();

  const { id } = useParams();

  const getNoticeDetail = async (notice_id) => {
    const { data } = await axios.get(
      `https://smsgaria.herokuapp.com/api/notice/${notice_id}/`
    );
    setNoticeDetail(data);
  };

  useEffect(() => {
    getNoticeDetail(id);
  }, [id]);

  console.log(id);
  console.log(noticeDetail);

  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="py-32  p-5 md:max-w-4xl mx-auto">
        <motion.h1
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: "2vh", opacity: 0 }}
          transition={{
            type: "spring",
            stiffness: 40,
            delay: 1,
            duration: 0.4,
          }}
          className="text-2xl font-semibold font-serif"
        >
          {noticeDetail?.notice_title}
        </motion.h1>
        <motion.div
          animate={{ x: 0 }}
          initial={{ x: "-100vw" }}
          transition={{ type: "spring", stiffness: 50, delay: 0.3 }}
          className=" w-36 h-1 bg-black"
        ></motion.div>
        <div className="mt-8">
          <motion.p
            animate={{ y: 0, opacity: 1 }}
            initial={{ y: "10vh", opacity: 0 }}
            transition={{
              type: "spring",
              stiffness: 40,
              delay: 1,
              duration: 0.2,
            }}
          >
            {ReactHtmlParser(noticeDetail?.notice)}
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default NoticeDetail;
